import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface PostConflictRestorationSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Choose a quiet, private time when the student is fully calm and regulated",
  'Start with connection, not correction (e.g., "It\'s good to see you feeling better")',
  'Acknowledge the student\'s emotions or perspective (e.g., "It seemed like you were really frustrated")',
  'Use restorative questions (e.g., "What happened?", "What were you feeling?", "Who was affected?")',
  "Help the student reflect on the impact of their behaviour in a safe, supportive way",
  'Guide problem-solving (e.g., "What could we try next time instead?")',
  "Collaboratively agree on steps to repair any harm (e.g., apology, action, responsibility)",
  'Reaffirm your relationship and belief in their ability to do well (e.g., "We\'ll work through it together")',
  "Provide a report of the incident to classroom teacher or executive staff",
  "Aim to settle emotions rather than resolve all issues if you are a visiting teacher",
  "Give a clear, low-pressure invitation to return to learning",
  "Avoid deep reflection or consequences if you are a visiting teacher",
];

export const PostConflictRestorationSection: React.FC<
  PostConflictRestorationSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe strategies for post-conflict discussions and relationship restoration:"
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label
        className="other-input-label"
        htmlFor="postConflictRestorationOther"
      >
        Other:
      </label>
      <input
        type="text"
        id="postConflictRestorationOther"
        name="postConflictRestorationOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
